// @ts-nocheck
import * as React from "react";

const Menu: React.FC = () => {
    return (
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path
                d="M20.05 16a.95.95 0 01.95.95v.1a.95.95 0 01-.95.95H3.95a.95.95 0 01-.95-.95v-.1a.95.95 0 01.95-.95h16.1zm0-5a.95.95 0 01.95.95v.1a.95.95 0 01-.95.95H3.95a.95.95 0 01-.95-.95v-.1a.95.95 0 01.95-.95h16.1zm0-5a.95.95 0 01.95.95v.1a.95.95 0 01-.95.95H3.95A.95.95 0 013 7.05v-.1A.95.95 0 013.95 6h16.1z"
                fill="currentColor"
                fillRule="evenodd"
                focusable="false"
            />
        </svg>
    );
};

export default React.memo(Menu);
